import axios from "../../utils/AxiosConfig";
import authHeader from "../../utils/authHeader";

// Fetch all Google Business Accounts for logged-in user
const fetchGoogleAccounts = async (token: string) => {
    const response = await axios.get("/google/accounts", {
        headers: authHeader(token),
    });
    return response.data;
};

// Fetch businesses under a selected account
const fetchGoogleLocations = async (token: string, accountId: Number) => {
    const response = await axios.get(`/google/accounts/${accountId}/locations`, {
        headers: authHeader(token),
    });
    return response.data;
};

const googleBusinessService = {
    fetchGoogleAccounts,
    fetchGoogleLocations,
};

export default googleBusinessService;
